<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="BellIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
      :badge="getUnreadNotifications"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ getUnreadNotifications }} непрочитанных</h3>
        <p class="opacity-75">уведомлений(-я)</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in getAllNotifications"
            :key="ntf.index"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="!ntf.is_viewed ? 'InfoIcon' : 'CheckCircleIcon'"
                :svgClasses="[
                  `text-${!ntf.is_viewed ? ntf.category : 'success'}`,
                  'stroke-current mr-1 h-6 w-6',
                ]"
              ></feather-icon>
              <div class="mx-2">
                <span
                  class="font-medium block notification-title"
                  :class="[`text-${!ntf.is_viewed ? ntf.category : 'success'}`]"
                  >{{ ntf.title }}</span
                >
                <small class="block my-2">{{ ntf.msg }}</small>
                <div class="-mx-1 flex">
                  <vs-button
                    @click="syncNotification(ntf)"
                    class="mx-1"
                    color="primary"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-external-link"
                    >Открыть</vs-button
                  >
                </div>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{
              elapsedTime(ntf.date_created)
            }}</small>
          </li>
        </ul>
        <template v-if="currentPagingationPage < maxPage">
          <vs-button
            @click="moreNotifications"
            class="mx-auto my-2 block"
            color="primary"
            type="relief"
            >Загрузить еще</vs-button
          >
        </template>
        <template v-else>
          <p class="text-center">Все уведомления загружены</p>
        </template>
      </component>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "NotificationDropDown",
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      notifications: [],
      unreadNotifications: 0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      currentPagingationPage: 1,
      countElements: 2,
    };
  },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    getUnreadNotifications() {
      return this.$store.getters.getUnreadNotifications;
    },
    getAllNotifications() {
      let notifications = this.$store.getters.getAllNotifications;
      notifications.forEach((notify) => {
        switch (notify.kind) {
          case "accounts":
            notify.link = `/residents/${notify.object_id}`;
            break;
          case "invoices":
            notify.link = `/payments`;
            break;
          case "applications":
          case "applications_message":
            notify.link = `/requests/application/${notify.object_id}`;
            break;
          case "consierge_service":
          case "consierge_service_message":
            notify.link = `/requests/consierge/${notify.object_id}`;
            break;
          case "security":
            notify.link = `/${notify.kind}`;
            break;
          case "passes":
            notify.link = `/${notify.kind}/${notify.object_id}`;
            break;
          case "booking":
            notify.link = `/requests/booking/${notify.object_id}`;
            break;
          default:
            notify.link = `/`;
        }
      });
      return notifications;
    },
    getCountNotifications() {
      return this.$store.getters.getCountNotifications;
    },
    maxPage() {
      return Math.ceil(this.getCountNotifications / 20);
    },
  },
  watch: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    elapsedTime(startTime) {
      const x = new Date(startTime);
      const now = new Date();
      let timeDiff = now - x;
      timeDiff /= 1000;

      const seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      const minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      const hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      const days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      if (days > 0) {
        return `${days + (days > 1 ? " дня(-ей) " : " день ")}`;
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? " часов " : " час ")}`;
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? " мин. " : " мин. ")}`;
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " секунд назад" : "только что");
      }

      return "только что";
    },
    moreNotifications() {
      if (this.currentPagingationPage < this.maxPage) {
        this.currentPagingationPage += 1;
        this.$store.dispatch("getNotifications", {
          page: this.currentPagingationPage,
        });
      }
    },
    getNotifications() {
      this.$store.dispatch("getNotifications", { page: 1 });
    },
    syncNotification(notify) {
      if (!notify.is_viewed) {
        this.$load(async () => {
          await this.$api.notifications
            .syncNotification(notify.id)
            .then((response) => {
              notify.is_viewed = true;
              if (this.$router.currentRoute.fullPath != notify.link) {
                this.$router.push(notify.link);
              } else {
                this.notification(
                  "Уведомление",
                  "Страница уже открыта",
                  "warning"
                );
              }
            })
            .catch((error) => {
              this.notification(
                "Ошибка",
                "Не удалось синхронизировать уведомления",
                "danger"
              );
            });
        });
      } else {
        if (this.$router.currentRoute.fullPath != notify.link) {
          this.$router.push(notify.link);
        } else {
          this.notification("Уведомление", "Страница уже открыта", "warning");
        }
      }
    },
  },
  created() {},
  mounted() {
    this.getNotifications();
  },
};
</script>

